import React, { useState } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { topNavbarBreakpoint } from 'config';
import PropTypes from 'prop-types';

import AuthCornerImage from 'assets/img/illustrations/authentication-corner.png';

import { breakpoints, capitalize } from 'helpers/utils';

const NavbarDropdown = ({ title, children, wide }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={() => setDropdownOpen(!dropdownOpen)}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <Dropdown.Toggle as={Link} to='#!' className='nav-link fw-semi-bold'>
        {capitalize(title)}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className='dropdown-menu-card mt-0 dropdown-caret'
        style={{ width: wide && '55rem' }}
      >
        {/* {children} */}
        <Card
          className={classNames('shadow-none dark__bg-1000', {
            'navbar-card-pages': title === 'pages',
            'navbar-card-components': title === 'modules',

            // default dropdown syling
            'navbar-card-app': title.length > 0,
          })}
        >
          <Card.Body
            className={classNames('scrollbar max-h-dropdown', {
              'p-0 py-2': title === 'dashboard' || title === 'documentation',
            })}
          >
            {title !== 'dashboard' && title !== 'documentation' && (
              <img
                src={AuthCornerImage}
                alt=''
                className='img-dropdown'
                width={130}
              />
            )}
            {children}
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

NavbarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  wide: PropTypes.bool,
};

export default NavbarDropdown;

